import type { DataTableColumn } from "@etudescarre/ui";
import { FilePdf as FilePdfIcon } from "@phosphor-icons/react";
import { useEffect } from "react";
import { useParams } from "react-router";
import { apiClient } from "@/lib/api/client";
import { Classeur, type FilterDef } from "../components/classeur";
import {
  useClasseurFilters,
  useClasseurState,
} from "../components/classeur/use-classeur-data";

type SlipItem = {
  id: string;
  number: string | null;
  createdAt: string;
  recipientCount: number;
  documentCount: number;
  hasPdf: boolean;
};

const columns: DataTableColumn<SlipItem>[] = [
  { id: "number", header: "N°", accessor: "number" },
  {
    id: "createdAt",
    header: "Date creation",
    accessor: "createdAt",
    cell: ({ value }) =>
      value ? new Date(value as string).toLocaleDateString("fr-FR") : "-",
  },
  { id: "recipientCount", header: "Destinataires", accessor: "recipientCount" },
  { id: "documentCount", header: "Documents", accessor: "documentCount" },
  {
    id: "pdf",
    header: "PDF",
    accessor: "hasPdf",
    cell: ({ value }) =>
      value ? (
        <FilePdfIcon size={18} className="text-red-600" />
      ) : (
        <span className="text-zinc-300">-</span>
      ),
  },
];

const filters: FilterDef[] = [];

export function ClasseurBordereauxEmisDO() {
  const { yardId } = useParams<{ yardId: string }>();
  const { activeFilters, onFilterChange } = useClasseurFilters({ filters });
  const [state, setState] = useClasseurState<SlipItem>();

  useEffect(() => {
    async function fetchData() {
      setState((prev) => ({ ...prev, isLoading: true }));
      const { data } = await apiClient.GET("/api/yards/{yardId}/slips", {
        params: {
          path: { yardId: yardId ?? "" },
          query: { type: "emis_do" },
        },
      });
      if (data) {
        const items = data.data.items.map((item) => ({
          ...item,
          id: String(item.id),
        }));
        setState({ items, total: data.data.total, isLoading: false });
      } else {
        setState({ items: [], total: 0, isLoading: false });
      }
    }
    fetchData();
  }, [yardId, setState]);

  return (
    <Classeur
      title="Classeur bordereaux émis pour avis"
      items={state.items}
      columns={columns}
      filters={filters}
      activeFilters={activeFilters}
      onFilterChange={onFilterChange}
      isLoading={state.isLoading}
      emptyMessage="Aucun bordereau emis"
      total={state.total}
    />
  );
}
